"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoAIPromptRecord = exports.autoAIAgentProviderStorageKey = exports.autoAISendODaysStorageKey = exports.autoAISendSkillsStorageKey = exports.autoAIProviderStorageKey = exports.autoAIPromptStore = void 0;
exports.initAutoAIPromptDb = initAutoAIPromptDb;
exports.getAutoAIPrompts = getAutoAIPrompts;
exports.saveAutoAIPrompt = saveAutoAIPrompt;
exports.updateAutoAIPrompt = updateAutoAIPrompt;
exports.deleteAutoAIPrompt = deleteAutoAIPrompt;
exports.getAutoAIProvider = getAutoAIProvider;
exports.getAutoAISettings = getAutoAISettings;
exports.saveAutoAISettings = saveAutoAISettings;
exports.getAutoAIAgentProvider = getAutoAIAgentProvider;
exports.saveAutoAIAgentProvider = saveAutoAIAgentProvider;
const IndexedDBStorage_1 = require("./IndexedDBStorage");
const autoAI_1 = require("../view/components/autoAI/model/autoAI");
const autoAIAgent_1 = require("../view/components/autoAIAgent/autoAIAgent");
exports.autoAIPromptStore = "AutoAIPromptStore";
exports.autoAIProviderStorageKey = "autoAILastUsedProvider";
exports.autoAISendSkillsStorageKey = "autoAISendSkills";
exports.autoAISendODaysStorageKey = "autoAISendODays";
exports.autoAIAgentProviderStorageKey = 'autoAIAgentLastUsedProviders';
class AutoAIPromptRecord {
    data;
    constructor(d) {
        this.data = d;
    }
    getStoreName() {
        return exports.autoAIPromptStore;
    }
    getKey() {
        return this.data.id;
    }
    toJSON() {
        return this.data;
    }
}
exports.AutoAIPromptRecord = AutoAIPromptRecord;
async function initAutoAIPromptDb() {
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    await db.init(exports.autoAIPromptStore);
    await db.createIndex(exports.autoAIPromptStore, {
        name: "userBranch",
        keyPath: ["userId", "branchId"],
    });
}
// load all prompts for a given user and branch
async function getAutoAIPrompts(userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const results = await db.getAllFromIndexInRange(exports.autoAIPromptStore, "userBranch", [userId, branchId], [userId, branchId]);
    const prompts = results
        .map(r => ({ id: r.id, date: r.date, message: r.message }))
        .sort((a, b) => b.date.localeCompare(a.date));
    return prompts;
}
// save a new prompt for a given user and branch
async function saveAutoAIPrompt(userId, branchId, message) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const record = {
        id: `${userId}-${branchId}-${new Date().valueOf()}`,
        userId,
        branchId,
        date: new Date().toISOString(),
        message,
    };
    await db.put(new AutoAIPromptRecord(record));
    return record;
}
async function updateAutoAIPrompt(prompt, userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const updated = {
        id: prompt.id,
        message: prompt.message,
        date: new Date().toISOString(),
        userId,
        branchId,
    };
    await db.put(new AutoAIPromptRecord(updated));
    return updated;
}
async function deleteAutoAIPrompt(prompt, userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const record = {
        id: prompt.id,
        userId,
        branchId,
        date: prompt.date,
        message: prompt.message,
    };
    await db.delete(new AutoAIPromptRecord(record));
}
function getAutoAIProvider() {
    const provider = window.localStorage.getItem(exports.autoAIProviderStorageKey);
    const option = autoAI_1.autoAIProviderOptions.find(option => option === provider);
    return option ?? autoAI_1.defaultAutoAIProvider;
}
function getAutoAISettings() {
    return {
        provider: getAutoAIProvider(),
        sendSkills: window.localStorage.getItem(exports.autoAISendSkillsStorageKey) === "true",
        sendODays: window.localStorage.getItem(exports.autoAISendODaysStorageKey) === "true",
    };
}
function saveAutoAISettings(settings) {
    window.localStorage.setItem(exports.autoAIProviderStorageKey, settings.provider);
    window.localStorage.setItem(exports.autoAISendSkillsStorageKey, String(settings.sendSkills));
    window.localStorage.setItem(exports.autoAISendODaysStorageKey, String(settings.sendODays));
}
function getAgentKey(userId, groupId, chatId) {
    return `${userId}:${groupId}:${chatId}`;
}
function getStoredProviders() {
    try {
        const storedProviders = window.localStorage.getItem(exports.autoAIAgentProviderStorageKey);
        if (!storedProviders) {
            return {};
        }
        const parsedProviders = JSON.parse(storedProviders);
        if (typeof parsedProviders === 'object' && parsedProviders !== null && !Array.isArray(parsedProviders)) {
            return parsedProviders;
        }
    }
    catch {
        // Ignore unavailable or invalid storage.
    }
    return {};
}
function getAutoAIAgentProvider(userId, groupId, chatId) {
    const provider = getStoredProviders()[getAgentKey(userId, groupId, chatId)];
    return autoAIAgent_1.autoAIAgentProviderOptions.find(option => option === provider) ?? autoAIAgent_1.defaultAutoAIAgentProvider;
}
function saveAutoAIAgentProvider(userId, groupId, chatId, provider) {
    try {
        const storedProviders = getStoredProviders();
        storedProviders[getAgentKey(userId, groupId, chatId)] = provider;
        window.localStorage.setItem(exports.autoAIAgentProviderStorageKey, JSON.stringify(storedProviders));
    }
    catch {
        // Ignore unavailable or invalid storage.
    }
}
